import $ from 'jquery';
import 'slick-carousel';

jQuery(function($) {

    $('.story-slider').each(function () {

        const $slider = $(this);

        // Find gallery items inside
        const $slides = $slider.find('.blocks-gallery-item');

        // Wrap items for Slick
        if ($slides.length) {

            $slides.wrap('<div class="slide"></div>');

            const $wrapper = $slider.find('.blocks-gallery-grid');

            $wrapper.slick({
                autoplay: false,
                arrows: true,
                dots: true,
                adaptiveHeight: true,
                loop: true,

                responsive: [
                    {
                        breakpoint: 1200,
                        settings: {
                            slidesToShow: 3,
                            centerMode: true,
                            centerPadding: '0px'
                        }
                    },
                    {
                        breakpoint: 580,
                        settings: {
                            slidesToShow: 1,
                            centerMode: true,
                            centerPadding: '20px'
                        }
                    }
                ]
            });
        }

    });

});